var _circle, _circle2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcBien(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 1,
    fill: "#1C1F20"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 14,
    r: 1,
    fill: "#1C1F20"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16ZM16 27C22.0751 27 27 22.0751 27 16C27 9.92487 22.0751 5 16 5C9.92487 5 5 9.92487 5 16C5 22.0751 9.92487 27 16 27Z",
    fill: "#1C1F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7071 21.7071C20.0976 21.3166 20.0976 20.6834 19.7071 20.2929C19.3199 19.9057 18.6943 19.9024 18.303 20.2829C18.3015 20.2843 18.2987 20.2868 18.2946 20.2904C18.2811 20.3022 18.2537 20.3253 18.2125 20.3563C18.13 20.4182 17.9933 20.5103 17.8028 20.6056C17.4251 20.7944 16.8272 21 16 21C15.1728 21 14.5749 20.7944 14.1972 20.6056C14.0067 20.5103 13.87 20.4182 13.7875 20.3563C13.7463 20.3253 13.7189 20.3022 13.7054 20.2904C13.7013 20.2868 13.6985 20.2843 13.697 20.2829C13.3057 19.9024 12.6801 19.9057 12.2929 20.2929C11.9024 20.6834 11.9024 21.3166 12.2929 21.7071L12.2943 21.7085L12.3278 21.7408C12.3437 21.7557 12.3639 21.7741 12.3884 21.7955C12.4373 21.8384 12.5037 21.8934 12.5875 21.9563C12.755 22.0818 12.9933 22.2397 13.3028 22.3944C13.9251 22.7056 14.8272 23 16 23C17.1728 23 18.0749 22.7056 18.6972 22.3944C19.0067 22.2397 19.245 22.0818 19.4125 21.9563C19.4963 21.8934 19.5627 21.8384 19.6116 21.7955C19.6361 21.7741 19.677 21.736 19.6929 21.7211L19.7008 21.7134L19.7041 21.7101L19.7057 21.7085L19.7071 21.7071Z",
    fill: "#1C1F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBien);
export default __webpack_public_path__ + "static/media/Ic_Bien.886068b11a08672df460c4c36f1e90a3.svg";
export { ForwardRef as ReactComponent };